module.exports = __webpack_public_path__ + "static/media/InstructionsSpotify.904e7199.jpg";